/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { throwError } from 'rxjs';

@Injectable({providedIn: 'root'})
export class BaseApiService {
  protected apiUrl = environment.apiUrl;
  protected _httpClient = inject(HttpClient);

  protected returnResponseData(response: any) {
    return response;
  }

  protected handleError(error: any) {
    return throwError(error);
  }

}
